
import { useTranslation } from 'react-i18next';

export default function Depoimentos() {
  const { t } = useTranslation();

  const testimonials = [
    {
      textKey: 'depoimentos.depoimento1',
      author: 'Ricardo Mendes',
      roleKey: 'depoimentos.proprietario',
      company: 'Restaurante Mar & Terra',
    },
    {
      textKey: 'depoimentos.depoimento2',
      author: 'Sofia Almeida',
      roleKey: 'depoimentos.diretora',
      company: 'Hotel Vila Azul',
    },
    {
      textKey: 'depoimentos.depoimento3',
      author: 'João Ferreira',
      roleKey: 'depoimentos.ceo',
      company: 'Boutique Essence',
    },
  ];

  /**
   * Safely translate a key, falling back to the key itself
   * if the translation is missing. This prevents the UI from
   * breaking when a translation entry is absent.
   */
  const safeT = (key: string) => {
    try {
      const result = t(key);
      // If i18next returns the key unchanged, treat it as missing.
      return result !== key ? result : key;
    } catch (err) {
      console.error(`Translation error for key "${key}":`, err);
      return key;
    }
  };

  return (
    <section className="py-24 lg:py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-black mb-6">
            {safeT('depoimentos.titulo')}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {safeT('depoimentos.subtitulo')}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow"
            >
              <div className="mb-6">
                {/* Escape the slash in Tailwind's opacity utility to avoid JSX parsing issues */}
                <i className="ri-double-quotes-l text-4xl text-black\\/10"></i>
              </div>
              <p className="text-gray-700 mb-6 leading-relaxed italic">
                &quot;{safeT(testimonial.textKey)}&quot;
              </p>
              <div className="border-t border-gray-200 pt-6">
                <p className="font-bold text-black">{testimonial.author}</p>
                <p className="text-sm text-gray-500">{safeT(testimonial.roleKey)}</p>
                <p className="text-sm text-gray-500">{testimonial.company}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
